import type { FunctionComponent } from 'react'
import React, { createContext, useContext } from 'react'
import type { Container, ServiceIdentifier } from './Container'
import { ComponentNotReady } from '@ztechapps/webui.util'

const DependencyContext = createContext<Container>({} as Container)

export const DependencyProvider: FunctionComponent<{
  container: Container
  children: React.ReactNode
}> = ({ container, children }) => {
  return <DependencyContext.Provider value={container}>{children}</DependencyContext.Provider>
}

function useInjectCore<T>(key: ServiceIdentifier): T {
  const container = useContext(DependencyContext)
  if (!container) {
    throw new Error('useInject must be used within a DependencyProvider')
  }

  try {
    return container.get<T>(key)
  } catch (e) {
    console.error(e)
    throw e
  }
}

export function useInjectComponent<T>(key: ServiceIdentifier): FunctionComponent<T> {
  try {
    return useInjectCore<FunctionComponent<T>>(key)
  } catch (e) {
    return () => (
      <ComponentNotReady>
        <div className="small fst-italic my-1 ">{e.message}</div>
      </ComponentNotReady>
    )
  }
}

export function useInject<T>(key: ServiceIdentifier): T {
  try {
    return useInjectCore<T>(key)
  } catch (e) {
    console.error(e)
  }
}
